/* loa-fb-cookie-sync.js — capture Meta's _fbp / _fbc cookies into Shopify cart attributes.
 *
 * WHY: tiktok-events-relay/meta_capi.py build_user_data() reads
 *      note_attributes["_fbp"] / ["_fbc"] when it sends server-side events to Meta's
 *      Conversions API. Nothing on the storefront wrote them, so they were always absent —
 *      which is exactly Meta's "your server is sending low coverage of fbp through
 *      Conversions API" diagnostic on dataset 929775693484378.
 *
 * WHY HERE AND NOT IN THE CUSTOM PIXEL: Shopify sandboxes web pixels. Sandboxed code cannot
 *      read the shop domain's cookies and cannot call the Cart AJAX API. Theme code can do both.
 *
 * SAFETY: purely additive. Everything is wrapped in try/catch, all failures are swallowed,
 *      it never blocks or alters an add-to-cart, and it writes at most once per session per
 *      value. Deleting this file and its script tag fully reverts it.
 *
 * Added 2026-08-06.
 */
(function () {
  try {
    if (window.__loaFbCookieSync) return;
    window.__loaFbCookieSync = true;
    var ownerWaits=0;

    function readCookie(name) {
      try {
        var m = document.cookie.match(new RegExp('(^|;\\s*)' + name + '=([^;]*)'));
        return m ? decodeURIComponent(m[2]) : '';
      } catch (e) { return ''; }
    }

    function fbcFromUrl() {
      try {
        var id = new URLSearchParams(window.location.search).get('fbclid');
        return id ? 'fb.1.' + Date.now() + '.' + id : '';
      } catch (e) { return ''; }
    }

    function sync() {
      try {
        var fbp = readCookie('_fbp');
        var fbc = readCookie('_fbc') || fbcFromUrl();
        if (!fbp && !fbc) return;

        var stamp = fbp + '|' + fbc;
        try {
          if (window.sessionStorage && sessionStorage.getItem('loa_fb_sync') === stamp) return;
        } catch (e) {}

        var attributes = {};
        if (fbp) attributes._fbp = fbp;
        if (fbc) attributes._fbc = fbc;

        var owner=window.EBCartV2||window.EnochCartV2;
        if(window.LOA_BUCKET==='funnel'&&(!owner||!owner.setAttributes)){
          if(ownerWaits++<10)setTimeout(sync,500);return;
        }
        var write=(window.LOA_BUCKET==='funnel'&&owner&&owner.setAttributes)
          ? owner.setAttributes(attributes)
          : fetch('/cart/update.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ attributes: attributes })
            });
        write.then(function () {
          try { if (window.sessionStorage) sessionStorage.setItem('loa_fb_sync', stamp); } catch (e) {}
        }).catch(function () {});
      } catch (e) {}
    }

    // _fbp is written by fbevents.js shortly after page load, so retry briefly.
    sync();
    setTimeout(sync, 1500);
    setTimeout(sync, 5000);
  } catch (e) {}
})();
